function addAffiliate() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const affiliateValue = urlParams.get("a");

  let af_code = localStorage.getItem("af_code");
  if (!affiliateValue || af_code === affiliateValue) {
    return;
  }

  localStorage.setItem("af_code", affiliateValue);
  localStorage.setItem("af_date", new Date().toISOString());
}
addAffiliate();

// order_source_ref is bound per (collection, variant). A user can land on
// different UTM-tagged URLs across a session and add multiple variants to the
// cart — each variant keeps the source it was referred under.
// The source value is a JSON string of whichever UTM params are present, e.g.
//   {"utm_source":"IGShopping","utm_medium":"Social","utm_campaign":"name"}
// Persisted as nested JSON:
//   localStorage.order_source_ref_bindings = { "<collectionId>": { "<variantId>": "<sourceJSON>" } }
// variation/src/index.jsx reads this at add-to-cart and writes the source
// JSON into the line item's `_order_source_ref` property.
var ORDER_SOURCE_UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

// Build a canonical JSON string from whichever UTM params are present, or ""
// when none are. Keys are emitted in ORDER_SOURCE_UTM_KEYS order so two equal
// URLs always serialize identically (needed for the URL-strip comparison).
function buildOrderSourceRefJSON(urlParams) {
  const obj = {};
  for (const key of ORDER_SOURCE_UTM_KEYS) {
    const value = urlParams.get(key);
    if (value) obj[key] = value;
  }
  return Object.keys(obj).length ? JSON.stringify(obj) : "";
}

function getOrderSourceRefBindings() {
  try {
    const raw = localStorage.getItem("order_source_ref_bindings");
    const parsed = raw ? JSON.parse(raw) : {};
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    // The earlier shape was a flat string at localStorage.order_source_ref
    // (no collection/variant scope). If we see a string value in the map,
    // the data is incompatible — discard and start fresh.
    for (const value of Object.values(parsed)) {
      if (typeof value === "string") return {};
    }
    return parsed;
  } catch (e) {
    return {};
  }
}

function setOrderSourceRefBindings(bindings) {
  localStorage.setItem("order_source_ref_bindings", JSON.stringify(bindings));
}

// Path looks like /products/collection_<digits>; the trailing numeric id is
// the collection id used as `_collectionId` in line item properties.
function getCollectionIdFromPath() {
  const match = window.location.pathname.match(/\/collection_(\d+)/);
  return match ? match[1] : null;
}

function addOrderSourceRef() {
  const urlParams = new URLSearchParams(window.location.search);
  const sourceJSON = buildOrderSourceRefJSON(urlParams);
  if (!sourceJSON) return;

  // The referred variant id is the empty-value numeric query param key,
  // matching variation/src/index.jsx getVariantIdFromURL.
  let urlVariant = null;
  for (const [key, value] of urlParams) {
    if (!isNaN(key) && value === "") {
      urlVariant = key;
      break;
    }
  }

  const collectionId = getCollectionIdFromPath();

  if (!urlVariant || !collectionId) {
    // UTM params without a (collection, variant) pair have no usable binding;
    // strip them.
    stripOrderSourceRefFromURL();
    return;
  }

  const bindings = getOrderSourceRefBindings();
  if (!bindings[collectionId] || typeof bindings[collectionId] !== "object") {
    bindings[collectionId] = {};
  }
  // Always overwrite the binding for this (collection, variant) — a fresh
  // visit to the URL with different UTM params replaces the prior source.
  if (bindings[collectionId][urlVariant] !== sourceJSON) {
    bindings[collectionId][urlVariant] = sourceJSON;
    setOrderSourceRefBindings(bindings);
  }
}
addOrderSourceRef();

function stripOrderSourceRefFromURL() {
  const url = new URL(window.location.href);
  let hasUtm = false;
  for (const key of ORDER_SOURCE_UTM_KEYS) {
    if (url.searchParams.has(key)) {
      hasUtm = true;
      break;
    }
  }
  if (!hasUtm) return;
  // Rebuild the query string manually to preserve the empty-value variant key
  // format (?100067011) — URLSearchParams.toString() would emit "100067011=".
  const parts = [];
  for (const [key, value] of url.searchParams) {
    if (ORDER_SOURCE_UTM_KEYS.indexOf(key) !== -1) continue;
    parts.push(value === "" ? key : key + "=" + encodeURIComponent(value));
  }
  const newSearch = parts.length ? "?" + parts.join("&") : "";
  window.history.replaceState(
    {},
    "",
    url.origin + url.pathname + newSearch + url.hash,
  );
}
